import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface ISimulationDescriptionParams {
  id: string;
  description: string;
}

export class SetSimulationDescriptionRequest extends Request<ISimulationDescriptionParams, IResult> {
  constructor(params: ISimulationDescriptionParams) {
    super('setSimulationDescription', params);
  }
}
